import { memo } from "react";
import { useStudio } from "../../../../context/Studio/useStudio";
import {
  ColorBleedingItem,
  ColorEndOfLifeItem,
  DeprecatedDesignItem,
  ProductDefinitionPart,
} from "../../../../types";
import { LeftSidebarItem } from "../components";
import { useTranslation } from "react-i18next";
import { useThemeBreakpoints } from "../../../../utils/themeUtils";

interface Props {
  partDefinition: ProductDefinitionPart;
  deprecatedDesignItems: DeprecatedDesignItem[];
  colorBleedingItems: ColorBleedingItem[];
  colorEndOfLifeItems: ColorEndOfLifeItem[];
}

const SpecElement = (props: Props) => {
  const { i18n } = useTranslation();
  const { isMobile } = useThemeBreakpoints();
  const {
    partDefinition,
    deprecatedDesignItems,
    colorBleedingItems,
    colorEndOfLifeItems,
  } = props;

  const {
    designState: {
      onSelectionChange,
      selection: { selectedPart, selectedElementName },
      designFromDesignState,
    },
    productName,
  } = useStudio();

  //find the part in the design
  const partDesign = designFromDesignState?.parts.find(
    (p) => p.name === partDefinition.name
  );

  const partElements = partDefinition.elements.map((elementDef) => {
    //See if the the element is in the partDesign (should be), and see if it's enabled or not
    let isEnabled = true;
    let reasonForBeingDisabled = { msg: "" };

    if (partDesign) {
      const elementDesign = partDesign.elements.find(
        (elementDesign) => elementDesign.name === elementDef.name
      );

      if (elementDesign) {
        isEnabled = elementDesign.enabled;
      }

      if (!isEnabled) {
        //For now we simplify and only show the first reason why disabled
        if (
          elementDesign?.reasonForBeingDisabled &&
          elementDesign.reasonForBeingDisabled.length > 0
        ) {
          reasonForBeingDisabled = elementDesign.reasonForBeingDisabled[0];
        }
      }
    }

    const deprecatedChildItems = deprecatedDesignItems?.filter(
      (d) => d.elementName === elementDef.name
    );

    const colorBleedingChildItems = colorBleedingItems?.filter(
      (d) => d.elementName === elementDef.name
    );

    const colorEndOfLifeChildItems = colorEndOfLifeItems?.filter(
      (d) => d.elementName === elementDef.name
    );

    const labelKey =
      elementDef.name === partDefinition.mainElement && productName
        ? `specs.${productName}.${partDefinition.name}`
        : `specs.${productName}.${elementDef.name}`;

    const isSelected =
      partDefinition.name === selectedPart &&
      elementDef.name === selectedElementName;

    return {
      onClick: isEnabled
        ? () => {
            if (isMobile) {
              isSelected
                ? onSelectionChange("", "")
                : onSelectionChange(partDefinition.name, elementDef.name);
            } else {
              onSelectionChange(partDefinition.name, elementDef.name);
            }
          }
        : undefined,
      productName: productName,
      name: elementDef.name,
      labelKey: i18n.exists(labelKey) ? labelKey : "",
      isSelected: isSelected,
      display: elementDef.display,
      enabled: isEnabled,
      reasonForBeingDisabled: reasonForBeingDisabled,
      deprecatedDesignItems: deprecatedChildItems,
      colorBleedingItems: colorBleedingChildItems,
      colorEndOfLifeItems: colorEndOfLifeChildItems,
    };
  });

  //filteredElements is all elements except the main element
  const filteredElements = partElements.filter(
    (e) => e.name !== partDefinition.mainElement
  );
  const mainElement = partElements.find(
    (e) => e.name === partDefinition.mainElement
  );

  return (
    <>
      {mainElement && <LeftSidebarItem item={mainElement} />}

      {filteredElements.map(
        (o) =>
          o.display.displayable && <LeftSidebarItem item={o} key={o.name} />
      )}
    </>
  );
};

export default memo(SpecElement);
